export default __webpack_public_path__ + "static/media/02.78702b22.jpg";